exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".aCol[data-v-be634728] {\n  position: relative;\n}\n.aCol .spanCol[data-v-be634728] {\n  color: red;\n  position: absolute;\n  left: 50px;\n  top: 11px;\n}\n", ""]);

// exports
